import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseClass } from '../../base-class/base-class';
import { IbaseService } from '../../base-service/ibase-service';
import { WebserviceService } from '../../services/webservice.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-market-analysis',
  templateUrl: './market-analysis.component.html',
  styleUrls: ['./market-analysis.component.css']
})
export class MarketAnalysisComponent extends BaseClass<any> implements OnInit {

  public data: any;
  public eventTypes: any[] = [];
  submitted = false;
  public exposer: any = 0;
  @Output() closeModal = new EventEmitter();

  constructor(
    private service: WebserviceService,
    public router: Router,
    ) { super(document) }

  ngOnInit(): void {
    this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.getServices().Get(`${this.env.baseUrl + this.api.marketAnalysis}`).subscribe(
      (res) => {
        // res = {"data":{"exposes":{"8.9994316":[{"expose":"980.00","event_id":31721095,"market_id":"8.9994316","market_type_id":"BOOK_MAKER","runner_name":"England Women","event_type_id":"4","selection_id":"890529","event_name":"England Women v India Women","fancy_name":null,"bookmaker_name":"To Win The Toss","bookmaker_runner_name":"England Women"},{"expose":"-1000.00","event_id":31721095,"market_id":"8.9994316","market_type_id":"BOOK_MAKER","runner_name":"India Women","event_type_id":"4","selection_id":"2030174","event_name":"England Women v India Women","fancy_name":null,"bookmaker_name":"To Win The Toss","bookmaker_runner_name":"India Women"}]}},"status":true,"error":{"message":"","code":0}};
        if (res.status == true) {
          let priority: any = { "MATCH_ODDS": 1, "BOOK_MAKER": 2, "FANCY": 3 }
          let eIds: any[] = [];
          res.data["list"] = [];
          res.data["events"] = [];
          Object.keys(res.data.exposes).forEach(key => {
            res.data["list"] = [...res.data["list"], ...res.data.exposes[key]];

            // calculate total exposer
            const exps = res.data.exposes[key].map((a: any) => a.expose)
            const highestAmount = (exps.filter((a: any) => a < 0).length > 0) ? Math.max(...exps.filter((a: any) => a < 0)) : 0;
            if (highestAmount && Math.sign(highestAmount) == -1)
              this.exposer -= highestAmount;
          });

          // console.log(res.data["list"]);
          res.data["list"].forEach((element:any) => {
            if(element.bookmaker_name && element.bookmaker_name.includes('MINI BOOKMAKER')) {
              element.market_type_id = 'MINI_BOOKMAKER'
            }
          });


          eIds = [...new Set(res.data["list"].map((a: any) => a.event_id))];
          // console.log(eIds);
          res.data.exposes = Object.entries(res.data.exposes).map(([key, value]) => ({ key: key, value: value }));
          // console.log(res.data.exposes);

          eIds.forEach(eid => {
            let eList = res.data.list.filter((el: any) => el.event_id == eid);
            let mIds = [...new Set(eList.map((a: any) => a.market_type_id))];
            // console.log(mIds);

            let data: any[] = []
            mIds.forEach(mid => {
              let mList = eList.filter((el: any) => el.market_type_id == mid);
              data.push({ 'market_id': mList[0].market_id, 'market_type_id': mList[0].market_type_id, 'market_data': mList, sort: priority[mList[0].market_type_id] })
            });

            data.sort((a, b) => {
              return a.sort - b.sort;
            });
            res.data.events.push({ 'event_name': eList[0].event_name, 'event_type_id': eList[0].event_type_id, 'event_id': eList[0].event_id, 'data': data })
          });

          // eIds.forEach(eid => {
          //   Object.keys(res.data.exposes).forEach(key => {

          //   })
          // });
          // console.log(res);

          this.data = res.data;
          // console.log(this.data);

          this.eventTypes.forEach((element: any) => {
            element["data"] = res.data.events.filter((x: any) => x.event_type_id == element.id);
          });

        }
      },
      (err) => {
        console.log(err);
      });
  }

  detailPage(e: any) {
    this.router.navigate([`${this.env.isMobile ? '/m/game-detail' : '/game-detail'}`, e.event_id]);
  }

  close() {
    this.closeModal.emit(true);
  }

}
